import axios, { type AxiosInstance, type CreateAxiosDefaults } from 'axios'

export interface AxiosClientConfig extends CreateAxiosDefaults {
  browserBaseUrl?: string
}

export function createAxiosClient({
  browserBaseUrl,
  ...defaults
}: AxiosClientConfig = {}): AxiosInstance {
  return axios.create({
    ...defaults,
    baseURL: import.meta.client ? browserBaseUrl : defaults.baseURL,
  })
}
